import { getWordCount } from "@memorang/helpers/string";
import type { BaseItemSchema, WordLimit } from "@memorang/types";
import useAIFeedbackStore from "../../hooks/useAIFeedbackStore";

const getWordLimit = (item: BaseItemSchema): WordLimit | undefined => {
	const response = item.response;
	return response && "wordLimit" in response ? response.wordLimit : undefined;
};

const useMeetsMinWords = (item: BaseItemSchema) => {
	const itemId = item.id!;
	const text = useAIFeedbackStore((s) => s.userResponse?.[itemId]);
	const wordLimit = getWordLimit(item);

	if (wordLimit?.min == null) {
		return true;
	}

	const wordCount = getWordCount(typeof text === "string" ? text : undefined);
	return wordCount >= wordLimit.min;
};

export default useMeetsMinWords;
